<template>
    <div>
        <b-navbar toggleable="md" type="dark" variant="dark" fixed="top">

            <b-navbar-brand :to="{path: '/'}">
                <div class="d-flex align-items-center">
                    <div class="mr-2">
                        <b-img src="//cdn.studiesweekly.com/img/sbp_logo.svg" width="30" height="auto" />
                    </div>
                    <div class="font-weight-bolder">SBP</div>
                </div>
            </b-navbar-brand>

            <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

            <b-collapse id="nav-collapse" is-nav>
                <b-navbar-nav>
                    <b-nav-item :to="{path: '/publications'}">Publications</b-nav-item>
                </b-navbar-nav>

                <b-navbar-nav>
                    <b-nav-item :to="{path: '/trunks'}">Trunks</b-nav-item>
                </b-navbar-nav>

                <b-navbar-nav>
                    <b-nav-item :to="{path: '/weeks'}">Weeks</b-nav-item>
                </b-navbar-nav>

                <b-navbar-nav>
                    <b-nav-item :to="{path: '/articles'}">Articles</b-nav-item>
                </b-navbar-nav>

                <b-navbar-nav>
                    <b-nav-item :to="{path: '/standards'}">Standards</b-nav-item>
                </b-navbar-nav>

                <b-navbar-nav>
                    <b-nav-item :to="{path: '/media'}">Media</b-nav-item>
                </b-navbar-nav>

                <b-navbar-nav>
                    <b-nav-item :to="{path: '/printables'}">Printables</b-nav-item>
                </b-navbar-nav>

                <b-navbar-nav v-if="can_request_report">
                    <b-nav-item :to="{path: '/reports'}">Reports</b-nav-item>
                </b-navbar-nav>

                <b-alert
                    v-if="host === 'sbpstage.studiesweekly.com' || host === 'stage-sbp.studiesweekly.com'"
                    class="py-1 mb-0 ml-3 px-2 bg-warning border-warning text-white flex-grow-1"
                    show
                >
                    <div class="d-flex align-items-center">
                        <div class="m-auto">
                            <font-awesome-icon :icon="['fad', 'exclamation-circle']" fixed-width /> You are currently using <strong>SBP Stage</strong>, which is for testing purposes.
                        </div>
                    </div>
                </b-alert>

                <!-- Right aligned nav items -->
                <b-navbar-nav class="ml-auto">
                    <b-nav-item v-if="errors && errors.length" class="errors" @click.prevent="showErrors">
                        <font-awesome-icon :icon="['fad', 'exclamation-circle']" />
                    </b-nav-item>

                    <b-nav-item-dropdown right>
                        <!-- Using 'button-content' slot -->
                        <template #button-content>
                            <v-gravatar :email="user.email" width="20" height="20" class="gravatar rounded-circle" />
                            <span class="align-middle mx-1">{{user.full_name}}</span>
                        </template>
                        <b-dropdown-item href="#" @click.prevent="showSettings">
                            <font-awesome-icon :icon="['fad', 'cog']" fixed-width /> Settings
                        </b-dropdown-item>
                        <b-dropdown-item v-if="can_admin" :to="{path: '/admin'}">
                            <font-awesome-icon :icon="['fad', 'user-edit']" fixed-width /> Admin Panel
                        </b-dropdown-item>
                        <b-dropdown-item href="#" @click.prevent="logout">
                            <font-awesome-icon :icon="['fad', 'sign-out']" fixed-width /> Sign Out
                        </b-dropdown-item>
                    </b-nav-item-dropdown>
                </b-navbar-nav>
            </b-collapse>
        </b-navbar>

        <errors-modal
            v-model="show_errors_modal"
            @hide="show_errors_modal = false"
        />

        <settings-modal
            v-model="show_settings_modal"
            @hide="show_settings_modal = false"
        />
    </div>
</template>

<style lang="scss" scoped>
@import "@/assets/css/_colors.scss";

.navbar {
    .navbar-nav {
        .nav-link:focus,
        .nav-link:hover {
            .gravatar {
                filter: brightness(1.15);
            }
        }
        .show > .nav-link,
        .nav-link.show {
            .gravatar {
                filter: brightness(1.25);
            }
        }
        .dropdown-toggle::after {
            vertical-align: middle;
        }
    }

    &.navbar-dark {
        .errors {
            .nav-link {
                color: $danger;
                &:focus,
                &:hover {
                    color: darken($danger, 10%);
                }
            }
        }
    }
}
</style>

<script>
import { mapState } from 'vuex'

import ErrorsModal from '@/components/modals/ErrorsModal'
import SettingsModal from '@/components/modals/SettingsModal'

export default {
    data: () => ({
        show_settings_modal: false,
        show_errors_modal: false,
        host: ''
    }),
    computed: {
        ...mapState({
            errors: state => state.errors.errors,
            user: state => state.user.user
        }),
        can_admin() {
            return this.user && this.user.permissions && _.includes(this.user.permissions, 'feature_admin')
        },
        can_request_report() {
            return this.user && this.user.permissions && _.includes(this.user.permissions, 'request_report')
        },
    },
    components: {
        ErrorsModal,
        SettingsModal
    },
    methods: {
        showErrors () {
            this.show_errors_modal = true
        },
        showSettings () {
            this.show_settings_modal = true
        },
        logout () {
            this.$store.dispatch('logout')
            .then(() => {
                this.$store.commit('setValidating', false)

                this.$store.commit('setUser', {})

                this.$router.push({
                    path: '/login'
                })
            })
        }
    },
    mounted() {
        if (window.location.host) {
            this.host = window.location.host
        }
    }
}
</script>
